import { useContext } from 'react';

import CartContext, { ICartContext } from './CartContext';

export default function useCart() {
  return useContext<ICartContext>(CartContext);
}
